import { gql } from "apollo-boost"

export const deleteEquipmentAttachment = gql`
  mutation deleteEquipmentAttachment($id:ID!) {
    DeleteEquipmentAttachment(id: $id)
  }
`